import ProjectReviewModalModule from './project-review-modal.module'

export default ProjectReviewModalModule
